export const PRODUCTION_STATUS_ORDER = [
  'pendiente_asignacion',
  'asignado',
  'en_produccion',
  'presentado_cliente',
  'cambios_solicitados',
  'aprobado_cliente',
  'pago_final_pendiente',
  'pago_final_confirmado',
  'brandkit_liberado',
  'entregado',
];

export function getProductionStatusRank(status) {
  const normalized = String(status || '').trim();
  return PRODUCTION_STATUS_ORDER.indexOf(normalized);
}

export function advanceProductionStatus(currentStatus, nextStatus, options = {}) {
  const current = String(currentStatus || '').trim();
  const next = String(nextStatus || '').trim();
  if (!next) return current;
  if (!current) return next;

  if (options.allowReviewReset && current === 'cambios_solicitados' && next === 'presentado_cliente') {
    return next;
  }

  const currentRank = getProductionStatusRank(current);
  const nextRank = getProductionStatusRank(next);
  if (nextRank === -1) return current;
  if (currentRank === -1) return next;
  return nextRank >= currentRank ? next : current;
}

function hasValue(value) {
  return value !== null && value !== undefined && value !== '' && value !== false;
}

export function resolveProductionStatus(project = {}, nextStatus = '', options = {}) {
  let candidate = nextStatus || '';

  if (hasValue(project.approval_act_signed_at)) {
    candidate = advanceProductionStatus(candidate, 'pago_final_pendiente');
  }
  if (hasValue(project.final_payment_paid_at)) {
    candidate = advanceProductionStatus(candidate, 'pago_final_confirmado');
  }
  if (hasValue(project.brandkit_unlocked_at)) {
    candidate = advanceProductionStatus(candidate, 'brandkit_liberado');
  }
  if (hasValue(project.delivery_act_signed_at)) {
    candidate = advanceProductionStatus(candidate, 'entregado');
  }

  return advanceProductionStatus(project.production_status, candidate, options);
}
